import AccessControl from '../access-control';

export default {
  'view': () => AccessControl.isAuthentificated()
}



// WEBPACK FOOTER //
// ./src/services/access-control/permissions/user-account.js